import React, { useState, useCallback } from 'react';

/**
 * Custom hook for hours and directions handler state.
 * @returns {{ selectedFacility: Object|null, setSelectedFacility: Function, handleMapAndHoursClose: Function }}
 */
export const useHoursAndDirectionsHandlers = () => {
	const [selectedFacility, setSelectedFacility] = useState(null);
	const handleMapAndHoursClose = useCallback(
		() => setSelectedFacility(null),
		[],
	);
	return { selectedFacility, setSelectedFacility, handleMapAndHoursClose };
};

function withHoursAndDirectionsHandlers(WrappedComponent) {
	const WithHoursAndDirectionsHandlers = (props) => {
		const hookResult = useHoursAndDirectionsHandlers();
		return (
			<WrappedComponent
				{...props}
				{...hookResult}
			/>
		);
	};
	WithHoursAndDirectionsHandlers.displayName = `withHoursAndDirectionsHandlers(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	return WithHoursAndDirectionsHandlers;
}

export default withHoursAndDirectionsHandlers;
